import axios from 'axios';
import { API_URL } from '../../common/constants';

export default {
  getStroke: async (id: number) => {
    try {
      const res = await axios.get(`${API_URL}/strokes/${id}/frontend/`);
      return res.data;
    } catch (e) {
      console.error('getStroke error:', e);
      return null;
    }
  },
  getStrokes: async () => {
    try {
      const res = await axios.get(`${API_URL}/strokes/frontend/all/`);
      return res.data;
    } catch (e) {
      console.error('getStrokes error:', e);
      return [];
    }
  },
};
